var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.24 4.703 2.245.194a1.514 1.514 0 0 0-1.5.008A1.49 1.49 0 0 0 0 1.492v9.016c0 .531.284 1.022.747 1.29.463.267 1.033.27 1.499.008l7.993-4.509C10.71 7.032 11 6.537 11 6a1.49 1.49 0 0 0-.76-1.297Z",
    fill: "currentColor"
  })));
};

export default SvgPlay;